jQuery(document).ready(function ($) {

  if (Shopify.country == "US") {
    Shopify.theme.currencyConverter.setCurrency('USD');
  } else if (Shopify.country == "BE" || Shopify.country == "EL" || Shopify.country == "LT" || Shopify.country == "PT" || Shopify.country == "BG" || Shopify.country == "ES" || Shopify.country == "RO" || Shopify.country == "CZ" || Shopify.country == "FR" || Shopify.country == "HU" || Shopify.country == "SI" || Shopify.country == "DK" || Shopify.country == "HR" || Shopify.country == "MT" || Shopify.country == "SK" || Shopify.country == "DE" || Shopify.country == "IT" || Shopify.country == "NL" || Shopify.country == "FI" || Shopify.country == "EE" || Shopify.country == "CY" || Shopify.country == "AT" || Shopify.country == "SE" || Shopify.country == "IE" || Shopify.country == "LV" || Shopify.country == "PL") {
    Shopify.theme.currencyConverter.setCurrency('EUR');
  } else if (Shopify.country == "GB") {
    Shopify.theme.currencyConverter.setCurrency('GBP');
  } else {
    Shopify.theme.currencyConverter.setCurrency('AUD');
  }
  if ($('[name="note"]').length) {
    $('body').on('change', '[name="note"]', function () {
      $('[name="note"]').val($(this).val());
    })
  }
  if ($('.post-with-tag').length) {
    $('.post-with-tag').each(function () {
      let listContainer = $(this).find('.post-list');
      let url = $(this).find('.see-all').attr('href');
      $.ajax({
        type: 'GET',
        url: url,
        dataType: 'html',
        success: function (html) {
          let $html = $(html);
          $html.find('.blog-main .blog-card').each(function (index) {
            if (index < 3) listContainer.append(this);
          })
          if (listContainer.length) {
            listContainer.addClass('owl-carousel');
            listContainer.owlCarousel({
              items: 3,
              nav: false,
              dots: false,
              margin: 0,
              responsive: {
                0: {
                  items: 1,
                  loop: true
                },
                568: {
                  items: 2,
                  loop: true
                },
                1024: {
                  items: 3
                }
              }
            });
            $('.blog-card .card-content').matchHeight();
          }
        },
        error: function (jqXHR, textStatus, errorThrown) {
          // console.log(jqXHR.responseText);
        }
      })
    })
  }
  if ($('a.product-thumbnail__title').length > 0) {
    $('a.product-thumbnail__title').matchHeight();
  }

  $('.close-message').click(function () {
    $(this).parent().hide();
  });

  $(".footer-top form.contact-form").validate();

  /* Add active when element has focus */
  //checkbox
  var input_selector = 'input[type=checkbox], input[type=radio]';
  $(input_selector).each(function () {
    selectId = $(this).attr('id')
    $('label[for="' + selectId + '"]').addClass('checkbox_radio');
  });
  //select
  var selectId = $("select").each(function () {
    selectId = $(this).attr('id')
    $('label[for="' + selectId + '"]').addClass('active');
    $('label[for="' + selectId + '"]').addClass('focusing');
  });
  //input
  function updateTextFields(input_selector) {
    setTimeout(function () {
      $(input_selector).each(function (index, element) {
        var $this = $(this);
        var inputId = $this.attr('id');
        if ($(element).val().length > 0 || $(element).is(':focus') || element.autofocus) {
          $('label[for="' + inputId + '"]').addClass('active');
        } else if ($(element)[0].validity.badInput) {
          $('label[for="' + inputId + '"]').toggleClass('active', $(element)[0].validity.badInput === true);
        } else {
          $('label[for="' + inputId + '"]').removeClass('active');
        }
        if ($(element).is(':focus')) {
          $('label[for="' + inputId + '"]').addClass('focusing');
        } else {
          $('label[for="' + inputId + '"]').removeClass('focusing');
        }
      });
    }, 300);
  };
  var input_selector = 'input[type=text], input[type=password], input[type=email], input[type=url], input[type=tel], input[type=number], textarea';
  var input_autofill = 'input:-webkit-autofill';
  updateTextFields(input_selector);
  $(window).on('load', function () {
    if ($(input_autofill)) {
      $(input_autofill).each(function () {
        $(this).parent().find('label').addClass('focusing');
      });
    }
  });
  $(document).on('change', input_selector, function () {
    var inputId = $(this).attr('id');
    if ($(this).val().length !== 0 || $(this).attr('placeholder') !== undefined) {
      $('label[for="' + inputId + '"]').addClass('active');
    }
  });
  $(document).on('focus', input_selector, function () {
    var inputId = $(this).attr('id');
    $('label[for="' + inputId + '"]').addClass('active');
    $('label[for="' + inputId + '"]').addClass('focusing');
    $(this).siblings('.prefix').addClass('active');
  });
  $(document).on('blur', input_selector, function () {
    var $inputElement = $(this);
    var selector = ".prefix";
    var inputId = $(this).attr('id');
    if ($inputElement.val().length === 0 && $inputElement[0].validity.badInput !== true && $inputElement.attr('placeholder') == '') {
      $('label[for="' + inputId + '"]').removeClass('active');
    }
    $('label[for="' + inputId + '"]').removeClass('focusing');
    $inputElement.siblings(selector).removeClass('active');
  });
  $('.block__product-faq .question').click(function () {
    var accordions = $(this).closest('.accordions');
    // accordions.find('.accordion').removeClass('active');
    // accordions.find('.answer').slideUp();
    $(this).closest('.accordion').toggleClass('active');
    $(this).next('.answer').slideToggle();
  })
  $('.product__information .accordion-title').click(function () {
    var accordions = $(this).closest('.accordions');
    var accordion = $(this).closest('.accordion');
    if (!accordion.hasClass('active')) {
      accordions.find('.accordion').removeClass('active');
      accordions.find('.description').slideUp();
    }
    $(this).closest('.accordion').toggleClass('active');
    $(this).next('.description').slideToggle();
  });

  $('.home-development-box .item-wrapper').addClass('owl-carousel');
  $('.home-development-box .item-wrapper').owlCarousel({
    items: 3,
    nav: false,
    dots: false,
    margin: 0,
    loop: true,
    responsive: {
      0: {
        items: 1,
        nav: true
      },
      1024: {
        items: 3
      }
    }
  })
  $('<h4 class="h2 review-title">Reviews</h4>').insertBefore('.block__product-yotpo-reviews .container .yotpo-main-widget');

  if ($('.blog-card .card-content').length > 0) {
    $('.blog-card .card-content').matchHeight();
  }

  $('.mobile-header .mobile-menu__toggle-icon .mobile-header__open-menu').click(function () {
    $('body').addClass('mobile-menu--opened');
    $('.mobile-header .mobile-header__content .mobile-dropdown .mobile-menu__toggle-icon').addClass('is-active');
  });
  $('.mobile-menu .mobile-menu__toggle-button').click(function () {
    $('body').removeClass('mobile-menu--opened');
    $('.mobile-header .mobile-header__content .mobile-dropdown .mobile-menu__toggle-icon').removeClass('is-active');
  });


  /* menu scroll */
  //Desktop
  //when window loaded
  $(window).on("load", function () {
    var url_string = window.location.href;
    if ($('body.index').length && url_string.indexOf('inside-section') != -1) {
      setTimeout(function () {
        jQuery('html,body').animate({ scrollTop: jQuery('#inside-section').offset().top }, 500);
      }, 500)
    }
  });
  $('.navbar .header__menu .navbar-item a.header__link').click(function (e) {
    var href = $(this).attr('href');
    if ($('body').hasClass('index')) {
      if (href.indexOf('inside-section') != -1) {
        $("html, body").animate({
          scrollTop: $('#inside-section').offset().top
        }, 1000);
      }
    }
  });
  $('.mobile-menu .mobile-menu__list .mobile-menu__item').click(function (e) {
    var href = $(this).attr('href');
    if ($('body.index').length > 0) {
      $('.mobile-menu--opened .mobile-header__close-menu').click();
      if (href.indexOf('#inside-section') != -1) {
        $("html, body").animate({
          scrollTop: $('#inside-section').offset().top
        }, 1000);
      }
    }
  });
  /* menu scroll */


  /* wholesalers page */
  if ($('.what-our-wholesalers-say-slider').length) {
    $('.what-our-wholesalers-say-slider').owlCarousel({
      items: 1,
      dots: false,
      nav: true,
      navText: ['<svg width="15" height="25" viewBox="0 0 15 25" fill="none"><path d="M14 24L2 12.5L14 1" stroke="white" stroke-width="2"/></svg>', '<svg width="15" height="25" viewBox="0 0 15 25" fill="none"><path d="M1 1L13 12.5L0.999999 24" stroke="white" stroke-width="2"/></svg>'],
      margin: 0,
      responsive: {
        0: {
          items: 1,
          loop: true
        },
        767: {
          items: 1,
          loop: true
        },
        768: {
          items: 1
        },
        1024: {
          items: 1
        }
      }
    });
  }
  $(".button-scroll").click(function (event) {
    event.preventDefault();
    var buttonId = $(this).attr('href');
    $('html, body').animate({
      scrollTop: $(buttonId).offset().top
    }, 1000);
  });
  /* wholesalers page */

  $(window).resize(function () {
    if ($(window).width() < 767) {
      setTimeout(function () {
        stopCarousel();
      }, 2000);
    }
  });
  if ($(window).width() < 767) {
    setTimeout(function () {
      stopCarousel();
    }, 3000);
  }
  function stopCarousel() {
    var owl = $('.indis-if-you .box-icon-wraper, .ndis-if-plan .box-icon-wraper');
    owl.trigger('destroy.owl.carousel');
    owl.addClass('off');
  }
});